export const headingPage = [
  { path: "boq", title: "boq" },
  { path: "boqlbm", title: "boq" },
  { path: "product", title: "product" },
  { path: "grounding", title: "product" },
  { path: "resource", title: "resource" },
  { path: "user", title: "setting" },
  { path: "log", title: "setting" },
];
